<template>
  <esg-base-dashboard>
    <b-row>
      <b-col>
        <!-- 법인별 온실가스 배출량 -->
        <all-corp-emission-by-scope @dataPointSelection="onDataPointSelection1"/>
        <!-- /법인별 온실가스 배출량 -->

        <!-- 사업장별 온실가스 배출량 모달창 - 법인별 온실가스 배출량 데이터 선택 시 보임 -->
        <esg-base-dashboard-modal id="esg-by-org-1"
                                  size="xl">
          <all-biz-loc-emission-by-scope :corporation="corporation1"/>
        </esg-base-dashboard-modal>
        <!-- /사업장별 온실가스 배출량 -->
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <!-- 법인 월별 온실가스 배출량 -->
        <selectable-corp-emission-by-month/>
        <!-- /법인별 월별 온실가스 배출량 -->
      </b-col>
    </b-row>

    <!-- 에너지원별 사용량 -->
    <b-row>
      <b-col>
        <selectable-corp-energy-by-fuel-with-biz-loc-info/>
      </b-col>
    </b-row>
    <!-- /에너지원별 사용량 -->

    <b-row>
      <b-col lg="6">
        <!-- 법인별 탄소집약도 -->
        <esg-base-dashboard-card title="탄소 집약도"
                                 :subtitle="`(법인 단위 - ${currentYear}년)`">
          <firmwide-carbon-intensity-by-corp @dataPointSelection="onDataPointSelection3"/>
          <b class="annotation">사업장별 세부정보를 보시려면 그래프를 클릭해주세요</b>
        </esg-base-dashboard-card>
        <!-- /법인별 탄소집약도 -->

        <!-- 사업장별 탄소 집약도 모당창 - 전사 법인별 탄소집약도의 데이터를 선택할 시 보임 -->
        <esg-base-dashboard-modal id="esg-by-org-3"
                                  size="md">
          <esg-base-dashboard-card :title="`${corporation3.name} 사업장별 탄소집약도`">
            <corp-carbon-intensity-by-biz-loc :corporation="corporation3"/>
          </esg-base-dashboard-card>
        </esg-base-dashboard-modal>
        <!-- /사업장별 탄소 집약도 모당창 -->
      </b-col>
    </b-row>
  </esg-base-dashboard>
</template>

<script>
import EsgBaseDashboard from "@/components/esg/base/EsgBaseDashboard.vue";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";

// 탄소 배출량
import AllCorpEmissionByScope from "../../dashboardCards/AllCorpEmissionByScope.vue";
import AllBizLocEmissionByScope from "../../dashboardCards/AllBizLocEmissionByScope.vue";

// 월별 탄소 배출량
import SelectableCorpEmissionByMonth from "../../dashboardCards/SelectableCorpEmissionByMonth.vue";

// 에너지 사용량
import SelectableCorpEnergyByFuelWithBizLocInfo
  from "../../dashboardCards/SelectableCorpEnergyByFuelWithBizLocInfo.vue";

// 탄소 집약도
import FirmwideCarbonIntensityByCorp from "../../charts2/FirmwideCarbonIntensityByCorp.vue";
import CorpCarbonIntensityByBizLoc from "../../charts2/CorpCarbonIntensityByBizLoc.vue";

export default {
  components: {
    EsgBaseDashboard,
    EsgBaseDashboardCard,
    EsgBaseDashboardModal,

    AllCorpEmissionByScope,
    AllBizLocEmissionByScope,

    SelectableCorpEmissionByMonth,

    SelectableCorpEnergyByFuelWithBizLocInfo,

    FirmwideCarbonIntensityByCorp,
    CorpCarbonIntensityByBizLoc,
  },
  data() {
    return {
      corporation1: {},
      corporation3: {},
      colors: [
        "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0",
        "#3F51B5", "#546E7A", "#D4526E", "#8D5B4C", "#F86624",
        "#D7263D", "#1B998B", "#2E294E", "#F46036", "#E2C044"
      ]
    }
  },
  methods: {
    onDataPointSelection1(corporation) {
      this.corporation1 = corporation;
      this.$bvModal.show('esg-by-org-1');
    },
    onDataPointSelection3(corporation) {
      this.corporation3 = corporation;
      this.$bvModal.show('esg-by-org-3');
    }
  }
}
</script>

<style scoped>
>>> .annotation {
  font-size: 10px;
  font-weight: 500;
  font-family: NanumGothic;
  color: #888;
}
</style>